module.exports = __webpack_public_path__ + "img/facebook.0bc933fb.svg";